<template>
  <el-scrollbar>
    <div style="margin: 15px">
      <h4>员工信息:</h4>
      <div class="box">
        <el-form label-width="150px">
          <el-row>
            <el-col :span="11">
              <el-form-item label="工号：" required>
                <el-input v-model="supportRecord.employee_no" placeholder="工号" @blur="employeeNoChange"
                          :disabled="isDetail || isEdit">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="姓名：" required>
                <el-input v-model="supportRecord.employee_name" placeholder="姓名" disabled>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="厂区：" required>
                <el-select v-model="supportRecord.home_factory_id" placeholder="厂区"  filterable disabled>
                  <el-option v-for="item in factoryList" :key="item.id" :label="item.name" :value="item.id"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="公司：" required>
                <el-input v-model="supportRecord.company_name" placeholder="公司" disabled/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="部门：" required>
                <el-cascader v-model="supportRecord.department_ids" :options="deptCascader" disabled
                             :props="CascaderProp" :show-all-levels="true" style="width: 100%"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="岗位：" required>
                <el-input v-model="supportRecord.job_id" placeholder="岗位" disabled>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="职务：" required>
                <el-input v-model="supportRecord.position_id" placeholder="职务" disabled>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <h4>支援信息:</h4>
      <div class="box">
        <el-form label-width="150px">
          <el-row>
            <el-col :span="11">
              <el-form-item label="支援厂区：" required>
                <el-select v-model="supportRecord.support_factory_id" placeholder="支援厂区" filterable  :disabled="isDetail || isEdit">
                  <el-option v-for="item in factoryList" :key="item.id" :label="item.name" :value="item.id"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="部门：" required v-show="isEdit">
                <el-cascader
                    v-model="supportRecord.support_department_ids"
                    :show-all-levels="true"
                    :options="deptCascader"
                    :props="optionProps"
                    placeholder="部门"
                    clearable
                    style="width: 100%"
                ></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="支援开始时间：" required>
                <el-date-picker v-model="supportRecord.start_date" type="date"
                                value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%" :disabled="isDetail || isEdit"/>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="支援结束时间：" required>
                <el-date-picker v-model="supportRecord.end_date" type="date"
                                value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%" :disabled="isDetail || isEdit"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="备注：">
                <el-input v-model="supportRecord.remark" placeholder="备注" :disabled="isDetail || isEdit">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <label style="margin-left: 5px;font-weight: bold">其它附件:</label>
      <div class="box">
        <el-form label-width="150px"  :disabled="isDetail || isEdit">
          <el-row>
            <el-col :span="12">
              <el-form-item label="附件：">
                <kf-file-upload v-model="supportRecord.file_id" :init-file="fileList"
                                @fileChange="fileChange"
                                :limit="10" :showTotalCnt="true"></kf-file-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="附件照片：">
                <el-button type="primary" style="width: 100px;" plain @click="openCameraMain">附件拍照</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="">
                <FrameItem v-model="attach_photo_id" :file-list="attach_photo_id_obj" :item="uploadImgObj"></FrameItem>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="display: flex;justify-content: center;margin-bottom: 20px">
        <el-button type="primary" @click="saveButton">保存</el-button>
      </div>
    </div>
  </el-scrollbar>
  <el-dialog v-model="dialogVisibleTwo" style="width: 800px;height: 550px;">
    <img id="view1" src="http://127.0.0.1:38088/video=stream&camidx=0" alt="主摄像头" style="width: 770px;height:450px;">
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="closeCameraMain">取消</el-button>
        <el-button type="primary" @click="takePhotoTwo">
          拍照
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: "EmployeeSupportAdd",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      optionProps: {
        emitPath:true,
        value: 'id',
        label: 'name',
        checkStrictly:true
      },
      CascaderProp: {
        emitPath: true,
        label: "name",
        value: "id",
        checkStrictly:true
      },
      isDetail: false,
      isEdit: false,
      change_item_id: '',
      deptCascader: [],
      factoryList: [],
      companyList: [],
      supportRecord: {},
      options: {
        change_item_id_options: [],
        /*status_options:[],*/
        position_options: [],
        employee_type_options: [],
        rank_options: [],
        salary_type_options: []
      },
      change_item_time: '',
      remark: '',
      employee_no: '',
      employee_name: '',
      company_name: '',
      before_factory_id: '',
      before_company_id: '',
      before_department_ids: '',
      before_position_id: '',
      before_job_id: '',
      factory_id: '',
      company_id: '',
      department_ids: '',
      position_id: '',
      job_id: '',
      is_already_change_salary: false,
      record_item_time: '',
      file_id: [],
      fileList: [],
      dialogVisibleTwo:false,
      uploadImgObj:{
        component: 'image_upload',
        limit: 1,
      },
      attach_photo_id:'',
      attach_photo_id_obj:[],
      positionOption:[],
      departmentList:[]
    }
  },
  methods: {
    async loadSupportInfo() {
      let params = {id: this.parentData.id}
      let dbEmployee = await this.$http('employeeSupportService.getSupportInfo', params);
      if (dbEmployee) {
        this.supportRecord = dbEmployee;
        this.isEdit = true;
      }
    },
    //获取厂区
    async getFactory() {
      let params = {modelId: "hr_document"}
      this.factoryList = await this.$http('sysFactoryService.getAllFactory', params);
    },
    //获取公司
    async getCompany() {
      this.company_id = '';
      let params = {factory_id: this.factory_id}
      this.companyList = await this.$http('sysFactoryService.getCompanyByFactory', params);
      console.log('companyList', this.companyList)
    },
    //获取文件
    async getAttachments() {
      let params = {
        file_id: this.file_id
      }
      console.log('aaa', params)
      this.formData = await this.$http('fileService.getAttachments', params)
      if (this.formData) {
        this.fileList = this.formData.attachmentsList;
      }
    },

    async fileChange(ids) {
      if (ids.length <= 0) {
        return
      }
      this.file_id = ids;
    },

    async saveButton() {
      let flag = this.checkForm()
      if (!flag) {
        return
      }
      let params = this.supportRecord;
      await this.$http("employeeSupportService.addSupport", params);
      this.$message.success("保存成功！");
      this.$fn.closeWindow();
      this.$fn.search();
    },
    checkForm() {
      if (this.supportRecord.employee_no == null || this.supportRecord.employee_no === '') {
        this.$message.error("请输入员工工号！");
        return false;
      }
      if(this.supportRecord.start_date == null || this.supportRecord.start_date === ''){
        this.$message.error("请选择支援开始时间！");
        return false;
      }
      if(this.supportRecord.end_date == null || this.supportRecord.end_date === ''){
        this.$message.error("请选择支援结束时间！");
        return false;
      }
      if(this.supportRecord.support_factory_id == null || this.supportRecord.support_factory_id === ''){
        this.$message.error("请选择支援厂区！");
        return false;
      }
      return true;
    },

    async getOptions() {
      let data = await this.$http("employeeChangeRecordService.getAllOptionsCaseStatus");
      this.options.position_options = data.position_options
      /*this.options.status_options = data.status_options*/
      this.options.employee_type_options = data.employee_type_options
      this.options.salary_type_options = data.salary_type_options
      this.options.rank_options = data.rank_options
    },
    //获取新增和编辑的异动类型下拉框
    async getAddChangeOptionsOptions() {
      let data = await this.$http("employeeChangeRecordService.getChangeItemsOptions");
      this.options.change_item_id_options = data.change_item_id_options
    },
    //获取详细的异动类型下拉框
    async getDetailChangeOptionsOptions() {
      let data = await this.$http("employeeChangeRecordService.getDetailChangeItemsOptions");
      this.options.change_item_id_options = data.change_item_id_options
    },
    async getDepartmentCascader() {
      let params = {support_factory_id: this.supportRecord.support_factory_id}
      console.log('params', params)
      this.deptCascader = await this.$http("sysUserDepartmentService.getSupportDepartmentData",params);
    },
    //获取职位
    async getPositionOption() {
      let params = {group_id: "职位"}
      this.positionOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    async employeeNoChange() {
      if (this.supportRecord.employee_no === ''){
        return
      }
      let params = {
        employee_no: this.supportRecord.employee_no
      }
      let data = await this.$http("employeeInfoService.getByEmployeeNoWithSalary", params);
      if (!data) {
        this.$message.error("该员工不存在或已离职！");
        this.supportRecord = {};
        return
      }
      this.supportRecord.employee_no = data.employee_no
      this.supportRecord.employee_name = data.employee_name
      this.supportRecord.home_factory_id = data.factory_id;
      this.supportRecord.beforecompany_id = data.company_id;
      this.supportRecord.company_name = data.company_name;
      this.supportRecord.department_ids = data.department_ids;
      this.supportRecord.position_id = data.position_id;
      this.supportRecord.job_id = data.job_id;
    },

    async salaryTypeChange() {
      if (this.salary_change.after_salary_type == null) {
        return
      }
      this.salary_change.after_is_customization_subsidy = false
      this.salary_change.after_is_salary_car = false
      this.salary_change.after_is_salary_house = false
      this.salary_change.after_is_salary_on_job = false
      this.salary_change.after_is_salary_full_attendance = false
      this.salary_change.after_is_salary_work_year = false

      let params = {
        salary_type: this.salary_change.after_salary_type
      }
      let data = await this.$http("employeeChangeRecordService.salaryTypeChange", params);
      this.salary_change.after_is_salary_car = Boolean(data.salary_car)
      this.salary_change.after_is_salary_house = Boolean(data.salary_house)
      this.salary_change.after_is_salary_on_job = Boolean(data.salary_on_job)
      this.salary_change.after_is_salary_full_attendance = Boolean(data.salary_full_attendance)
      this.salary_change.after_is_salary_work_year = Boolean(data.salary_work_year)
    },
    async openCameraMain(){
      this.dialogVisibleTwo = true;
      const image = document.getElementById('view1');
      image.src = 'http://127.0.0.1:38088/video=stream&camidx=0?1';
    },
    closeCameraMain(){
      let data = {"camidx": "0"}
      axios.post("http://127.0.0.1:38088/video=close", JSON.stringify(data)).then(()=>{
        document.getElementById('view1').src = ''
      });
      this.dialogVisibleTwo = false;
    },
    takePhotoTwo(){
      let params = {
        "filepath": "base64",
        "camidx": "0",
        "ColorMode": "0",
        "quality": "1"
      }
      axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(params)).then(response=>{
        if(response){
          let photoData = {photo: response.data};
          this.$http('photoService.takePhotoByMainCamera',photoData, false).then(data => {
            if(data){
              this.attach_photo_id = data.avatar;
              this.attach_photo_id_obj = [data.file];
              this.dialogVisibleTwo = false;
            }
          }, errMsg => {
            this.$message.error(errMsg)
            console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          });
        }
      });
    },
  },
  created() {
    this.getCompany();
    this.loadSupportInfo().then(() => {
      this.getAttachments();
      this.getDepartmentCascader();
    });
    this.getAddChangeOptionsOptions();
    this.getOptions()
    this.getPositionOption()
    this.getFactory();
  },

}
</script>

<style scoped lang="less">
.box {
  padding-top: 10px;
  border: 1px solid black;
  border-radius: 5px;
  border-color: #cccccc;
  margin: 10px 0;
}

.checkbox-group {
  display: flex;
  flex-direction: column;
}

.custom-label {
  font-size: 16px;
  font-weight: bold;
}


</style>